import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExpandCircleDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"expand_circle_down"}/>
}
